/* Dostępne metody HTTP. */
export const HTTP_METHOD__GET = 'get';
export const HTTP_METHOD__POST = 'post';
export const HTTP_METHOD__PATCH = 'patch';
export const HTTP_METHOD__PUT = 'put';
export const HTTP_METHOD__DELETE = 'delete';
export const HTTP_METHOD__HEAD = 'head';

/* Dostępne typy odpowiedzi HTTP. */
export const RESPONSE_TYPE__JSON = 'json';
export const RESPONSE_TYPE__TEXT = 'text';
export const RESPONSE_TYPE__STREAM = 'stream';
export const RESPONSE_TYPE__BLOB = 'blob';

/* Dostępne nazwy nagłówków HTTP. */
export const HEADER_NAME__AUTHORIZATION = 'Authorization';
export const HEADER_NAME__CACHE_CONTROL = 'Cache-Control';
export const HEADER_NAME__CONTENT_TYPE = 'Content-Type';
export const HEADER_NAME__EXPIRES = 'Expires';
export const HEADER_NAME__PRAGMA = 'Pragma';

/* Wartości przesyłane w nagłówkach HTTP. */
export const HEADER_VALUE__CACHE_CONTROL = 'no-cache, no-store, must-revalidate';
export const HEADER_VALUE__CONTENT_TYPE = 'application/json';
export const HEADER_VALUE__EXPIRES = '0';
export const HEADER_VALUE__PRAGMA = 'no-cache';

export const HEADER_VALUE__CONTENT_TYPE__FILE_UPLOAD = 'multipart/form-data; boundary=----boundary----';

// Tekst na podstawie którego jesteśmy w stanie stwierdzić,
// że złapany wyjątek związany jest z problemami sieciowymi.
export const NETWORK_ERROR = 'Network Error';

// Limit czasu.
export const TIMEOUT = 60000;
